import { MetaReducer } from '@ngrx/store';
import { hydrationMetaReducer } from '../store/meta-reducers/hydration.reducer';

export const META_REDUCERS: MetaReducer<any>[] = [hydrationMetaReducer];
